import React from "react";

function BiddingProcess_Hero(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 20 20"
      className={props.className}
    >
      <path
        fill="#262626"
        d="M7.244 9.36V6.247c0-.185.065-.344.196-.475a.647.647 0 01.477-.196c.187 0 .346.065.477.196.13.131.196.29.196.475V9.36a.647.647 0 01-.196.475.65.65 0 01-.477.196.65.65 0 01-.477-.196.647.647 0 01-.196-.475zm3.622 1.092V2.916a.65.65 0 01.196-.477.65.65 0 01.477-.197c.187 0 .346.066.476.197a.65.65 0 01.197.477v7.536c0 .225-.069.393-.207.505a.728.728 0 01-.93 0c-.14-.112-.21-.28-.209-.505zM3.59 12.237V9.582a.65.65 0 01.196-.476.65.65 0 01.478-.197c.187 0 .346.065.476.197a.65.65 0 01.196.476v2.656c0 .225-.069.393-.207.504a.728.728 0 01-.93 0c-.14-.112-.209-.28-.209-.504m.905 4.886a.386.386 0 01-.386-.254c-.071-.17-.04-.322.096-.458l3.257-3.256a.683.683 0 01.446-.202.614.614 0 01.47.16l2.488 2.138 5.628-5.628H15a.408.408 0 01-.417-.417A.406.406 0 0115 8.79h2.244c.19 0 .35.064.48.193a.652.652 0 01.193.48v2.243a.409.409 0 01-.418.417.407.407 0 01-.416-.417v-1.493l-5.753 5.753a.686.686 0 01-.446.202.614.614 0 01-.47-.161l-2.488-2.137-3.13 3.131a.477.477 0 01-.301.122z"
      ></path>
    </svg>
  );
}

export default BiddingProcess_Hero;
